/*
 * journal-today-badge
 */
import { useTranslation } from "react-i18next"
import { trpc } from "../../trpc"
import { FeatureBadge } from "./feature-badge"

export function JournalTodayBadge() {
	const { t } = useTranslation()
	const { data } = trpc.journalEntry.getHasEntryToday.useQuery()

	if (data?.hasEntry) {
		return null
	}

	return (
		<FeatureBadge
			label={t("features.journal.badgeNoEntry")}
			variant="secondary"
			className="h-3 w-3 p-0"
		/>
	)
}
